var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'gyosha-view-app': _vm.$route.name === 'GyoshaOrderView' }},[(_vm.$route.name !== 'GyoshaOrderView')?_c('base-system-bar'):_vm._e(),_c('base-snack-bar',{ref:"snackbar"}),_c('confirm-dialog',{ref:"confirm"}),_c('warning-dialog',{ref:"warning"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }